export enum LinkedAccountType {
  GOOGLE_PLAY = "google_play",
  UBISOFT = "ubisoft",
}
export interface LinkedAccount {
  createdAt: string;
  customData: Record<string, string>;
  externalUuid: string;
  kind: LinkedAccountType;
  updatedAt: string;
}
